import { neighbors, random, shuffled } from './53-game-primitives.mjs';

const topRun = (tube) => {
  let count = 0;
  for (let i = tube.length - 1; i >= 0 && tube[i] === tube.at(-1); i--) count++;
  return count;
};

/** Generate a four-marble puzzle by reversing legal pours from a solved board.
 * Every scramble step records an exact inverse, proving solvability rather than
 * trusting a random shuffle. The witness is for tests, not a renderer hint. */
export function marblePuzzle(state) {
  const colours = shuffled(state, [0, 1, 2, 3, 4, 5]).slice(0, 3);
  const tubes = colours.map((colour) => Array(4).fill(colour)).concat([[], []]);
  const solution = [];
  let previous = null;
  for (let step = 0; step < 22; step++) {
    const choices = [];
    for (let from = 0; from < tubes.length; from++) {
      const source = tubes[from];
      if (!source.length) continue;
      for (let to = 0; to < tubes.length; to++) {
        const destination = tubes[to];
        if (from === to || destination.at(-1) === source.at(-1)) continue;
        if (previous && previous.from === to && previous.to === from) continue;
        for (let count = 1; count <= Math.min(topRun(source), 4 - destination.length); count++) {
          if (count === topRun(source) && source.length > count) continue;
          if (!destination.length && count === source.length) continue;
          choices.push({ from, to, count });
        }
      }
    }
    if (!choices.length) break;
    const choice = choices[random(state, choices.length)];
    tubes[choice.to].push(...tubes[choice.from].splice(-choice.count));
    solution.unshift({ from: choice.to, to: choice.from, count: choice.count });
    previous = choice;
  }
  return { tubes, solution };
}

/** Author a bounded seeded spring-to-pool route, then place obstacles away from
 * its witness. Checkpoints lie in route order; no browser geometry or timing
 * enters policy. DFS has a fixed work budget and a reachable fallback. */
export function brookPuzzle(state) {
  let budget = 1200;
  const path = [0];
  function explore(index) {
    if (--budget <= 0) return false;
    if (index === 24) return path.length >= 11;
    if (path.length >= 19) return false;
    for (const next of shuffled(state, neighbors(index, 5, 25))) {
      if (path.includes(next)) continue;
      path.push(next);
      if (explore(next)) return true;
      path.pop();
    }
    return false;
  }
  if (!explore(0)) path.splice(0, path.length, 0, 1, 2, 3, 4, 9, 8, 7, 6, 11, 16, 17, 18, 19, 24);
  const checkpoints = [path[Math.floor(path.length / 3)], path[Math.floor((path.length * 2) / 3)]];
  const blocked = Array.from({ length: 25 }, (_, index) => index).filter(
    (index) => !path.includes(index) && random(state, 3) !== 0,
  );
  return { blocked, checkpoints, solution: [...path] };
}
